/**
 * Simple CSV parser with quoted-field support.
 * Extracted from Bank.jsx to keep the page component simple and testable.
 */
export function parseCSV(text) {
  const rows = [];
  let cur = [];
  let field = "";
  let inQ = false;
  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (inQ) {
      if (c === '"' && text[i + 1] === '"') { field += '"'; i++; }
      else if (c === '"') { inQ = false; }
      else field += c;
    } else {
      if (c === '"') inQ = true;
      else if (c === ",") { cur.push(field); field = ""; }
      else if (c === "\n") { cur.push(field); rows.push(cur); cur = []; field = ""; }
      else if (c === "\r") { /* skip */ }
      else field += c;
    }
  }
  if (field.length || cur.length) { cur.push(field); rows.push(cur); }
  return rows.filter(r => r.some(x => x && x.length));
}

/**
 * Detect bank-CSV column indices for date/description/amount/balance.
 * Case-insensitive substring match.
 */
export function detectBankColumns(headers) {
  const h = headers.map(x => (x || "").trim().toLowerCase());
  return {
    date: h.findIndex(x => x.includes("date")),
    description: h.findIndex(x => x.includes("desc") || x.includes("narr") || x.includes("payee") || x.includes("details")),
    amount: h.findIndex(x => x.includes("amount") || x.includes("value") || x.includes("debit") || x.includes("credit")),
    balance: h.findIndex(x => x.includes("balance")),
  };
}

const cleanNum = (s) => Number(String(s || "0").replace(/[€$,\s]/g, ""));

/**
 * Parse a raw bank CSV text blob into normalised transaction rows,
 * or throw a helpful error if the shape can't be detected.
 */
export function parseBankCSV(text) {
  const rows = parseCSV(text);
  if (rows.length < 2) throw new Error("CSV too small — expected header row + data");
  const idx = detectBankColumns(rows[0]);
  if (idx.date < 0 || idx.amount < 0) {
    throw new Error("Could not detect date/amount columns. Please check your CSV.");
  }
  return rows.slice(1).map(r => ({
    date: (r[idx.date] || "").trim(),
    description: idx.description >= 0 ? (r[idx.description] || "").trim() : "",
    amount: cleanNum(r[idx.amount]),
    balance: idx.balance >= 0 ? cleanNum(r[idx.balance]) : null,
    category: "Uncategorized",
  }));
}
